import PropTypes from 'prop-types';
// @flow

import React, { Component } from 'react';

import { ViewUtils } from 'PMT/utils';

// -- entities
import { ProductOption } from 'PMT/entities/menu';

import { PriceInput } from 'PMT/components/form';

export default class AddProductOptionsModalProductOptionRow extends Component {

  static propTypes = {
    productOption: PropTypes.objectOf(ProductOption).isRequired,

    /**
     * @param productOptionValue ProductOptionValue
     */
    onToggle: PropTypes.func.isRequired,

    isSelected: PropTypes.bool.isRequired
  };

  // -- getters

  get productOption() {
    return this.props.productOption;
  }

  // -- renderers

  render() {
    return (
      <div
        className="pointer select_product_options_modal__product_option_row"
        onClick={() => { this.props.onToggle(this.productOption) }}
      >
        {this.props.isSelected &&
          <i className="fa fa-check-square-o" />
        }
        {!this.props.isSelected &&
          <i className="fa fa-square-o" />
        }
        &nbsp;&nbsp;
        {this.productOption.name}
      </div>
    );
  }

}



// WEBPACK FOOTER //
// ./scripts/pages/menu/productEdit/components/selectProductOptions/SelectProductOptionsModalProductOptionRow.js